var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.23a6.77 6.77 0 100 13.54A6.77 6.77 0 008 1.23zM0 8a8 8 0 1116 0A8 8 0 010 8z",
    fill: "#B80000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.385 11.692v-1.23h1.23v1.23h-1.23zM7.385 9.23V4.309h1.23V9.23h-1.23z",
    fill: "#B80000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik04IDEuMjMwNzdDNC4yNjE0NiAxLjIzMDc3IDEuMjMwNzcgNC4yNjE0NiAxLjIzMDc3IDhDMS4yMzA3NyAxMS43Mzg1IDQuMjYxNDYgMTQuNzY5MiA4IDE0Ljc2OTJDMTEuNzM4NSAxNC43NjkyIDE0Ljc2OTIgMTEuNzM4NSAxNC43NjkyIDhDMTQuNzY5MiA0LjI2MTQ2IDExLjczODUgMS4yMzA3NyA4IDEuMjMwNzdaTTAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEMxMi40MTgzIDAgMTYgMy41ODE3MiAxNiA4QzE2IDEyLjQxODMgMTIuNDE4MyAxNiA4IDE2QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOFoiCiAgICBmaWxsPSIjQjgwMDAwIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4zODQ2MiAxMS42OTIzVjEwLjQ2MTVIOC42MTUzOVYxMS42OTIzSDcuMzg0NjJaIiBmaWxsPSIjQjgwMDAwIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4zODQ2MiA5LjIzMDc3VjQuMzA3NjlIOC42MTUzOVY5LjIzMDc3SDcuMzg0NjJaIiBmaWxsPSIjQjgwMDAwIiAvPgo8L3N2Zz4=";
export { SvgIconAlert as ReactComponent };